// eslint-disable-next-line no-unused-vars
import React, { useRef, useState, useEffect } from 'react';

export default function useOutside() {
  const [outSideState, setOutSideState] = useState(false);
  const wrapperRef = useRef(null);
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOutSideState(true);
      } else {
        setOutSideState(false);
      }
    }

    // Bind the event listener
    document.addEventListener('click', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('click', handleClickOutside);
    };
  }, [setOutSideState]);

  return [wrapperRef, outSideState];
}
